<template>
  <div class="sample-mutation mt-n4"
       :id="sample_mutation_id">
    <svg></svg>
  </div>
</template>

<script>
import * as d3 from 'd3';
import tippy, { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
export default {
  name: 'SampleMutation',
  props: {
    sampleMutationId: {
      type: String,
      default() {
        return null
      }
    },
    sampleId: {
      type: Array,
      default() {
        return []
      }
    },
    sampleMutation: {
      type: Array,
      default() {
        return []
      }
    },
    sampleCnv: {
      type: Array,
      default() {
        return []
      }
    },
    pValue: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      sample_mutation_id: null,
      sampleIDs: [],
      sampleMutations: [],
      sampleCNVs: [],
      p_value: null,
    }
  },
  created() {
    // console.log('子组件创建完成！');
  },
  mounted() {
    // 此处必须初始化 sampleId 为 [], 不然当添加突变基因时，watch 不到 sampleID 的变化
    // this.sampleId = [];
    // this.pValue = 0;
  },
  computed: {
  },
  watch: {
    sampleMutationId(newVal, oldVal) {
      // console.log(newVal, oldVal);
      if (newVal) {
        this.sample_mutation_id = newVal;
      }
    },
    sampleId(newVal, oldVal) {
      // console.log(newVal, oldVal);
      if (newVal.length > 0) {
        this.sampleIDs = newVal;
      }
    },
    sampleMutation(newVal, oldVal) {
      // console.log(newVal, oldVal);
      if (newVal.length > 0) {
        this.sampleMutations = newVal;
        setTimeout(() => {
          // console.log(this.p_value);
          this.initSampleMutationPlot();
        }, 500);
      }
    },
    sampleCnv(newVal, oldVal) {
      // console.log(newVal, oldVal);
      // maybe is []
      if (newVal.length > 0) {
        this.sampleCNVs = newVal;
      }
    },
    pValue(newVal, oldVal) {
      // console.log(newVal, oldVal);
      if (newVal) {
        this.p_value = newVal;
      }
    },
  },
  methods: {
    initSampleMutationPlot() {

      // all samples which have PSI
      let samples = this.sampleIDs;
      // console.log(samples);
      let sample_size = samples.length;

      // filter the mutaion samples which don't have PSI value
      //   let sampleMutations = this.sampleMutations.filter((v, i, a) => {
      //     return samples.includes(v.sample_id)
      //   });

      let sampleCNVs = this.sampleCNVs;

      let cnv;
      let all_samples_cnv = [];
      if (sampleCNVs.length > 0) {
        cnv = sampleCNVs[0].sample_cnv;
        // get the retained sampleIDs which have CNV
        let samplesID_in_cnv = [];
        if (sampleCNVs) {
          // console.log(sampleCNVs[0].sample_cnv[0]);
          cnv.forEach((v, i, a) => {
            samplesID_in_cnv.push(v.sample_id)
          })
        }
        // console.log(samplesID_in_cnv);

        // let all_samples_cnv = [];
        // get the sampleIDs which don't have cnv
        samples.forEach((v, i, a) => {
          if (!samplesID_in_cnv.includes(v)) {
            let sample = {};
            sample.sample_id = v;
            all_samples_cnv.push(sample);
          }
        });
        all_samples_cnv = [...all_samples_cnv, ...cnv]
        // console.log(all_samples_cnv);
      } else {
        // 如果不存在sampleCNVs， 设置 cnv 全为 0
        samples.forEach((v, i, a) => {
          let sample = {};
          sample.sample_id = v;
          sample.cnv = 0;
          all_samples_cnv.push(sample);
        });
      }

      let sampleMutations = this.sampleMutations;
      // get the retained sampleIDs which have mutation
      let samples_in_ids = [];
      sampleMutations.forEach((v, i, a) => {
        samples_in_ids.push(v.sample_id)
      });

      let all_samples_mutation = [];
      // get the sampleIDs which don't have mutation
      samples.forEach((v, i, a) => {
        if (!samples_in_ids.includes(v)) {
          let sample = {};
          sample.sample_id = v;
          all_samples_mutation.push(sample);
        }
      });
      all_samples_mutation = [...all_samples_mutation, ...sampleMutations]
      // console.log(all_samples_mutation);

      const margin = ({ top: 0, left: 200, right: 100, bottom: 0, });
      const width = sample_size * 8 + margin.left + margin.right;
      const height = 40;
      const gridWidth = 6;
      const gridHeight = 20;
      const sampleColor = "#BDBDBD";

      // console.log(this.genename);
      // Here, must replace this.sample_mutation_id as gene_name !!!
      let gene_name = this.sample_mutation_id;
      // console.log(gene_name);
      // console.log(this.p_value);
      // let pvalue = this.p_value && this.p_value.toFixed(3);
      let pvalue;
      if (this.p_value > 0) {
        pvalue = this.p_value && this.p_value.toFixed(3);
      } else {
        pvalue = '0.000';
      }
      let mutation_ratio = Math.round(sampleMutations.length / sample_size * 10000) / 100 + "%";
      // console.log(mutation_ratio);

      let bandName = gene_name + ' | ' + pvalue + ' | ' + mutation_ratio;
      // console.log(bandName);

      //   d3.selectAll("div.sample-mutation").each(function () { console.log(d3.select(this).attr('id')) })
      //   console.log(d3.selectAll("div.sample-mutation").filter(function () { return d3.select(this).attr('id') == gene_name }))

      const svg = d3.selectAll("div.sample-mutation")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .select('svg');
      // .attr("viewBox", [0, 0, width, height]);
      svg.attr("width", width);
      svg.attr("height", height);
      // console.log(svg);

      let categories = ["Missense_Mutation", "Silent", "3'UTR", "Nonsense_Mutation", "Frame_Shift_Del", "Intron", "5'UTR", "RNA", "Splice_Site",
        "Frame_Shift_Ins", "3'Flank", "5'Flank", "In_Frame_Del", "Translation_Start_Site", "Nonstop_Mutation", "In_Frame_Ins", "large deletion"];
      let colors = ["#1F77B4FF", "#FF7F0EFF", "#2CA02CFF", "#D62728FF", "#9467BDFF", "#8C564BFF", "#E377C2FF", "#7F7F7FFF", "#BCBD22FF",
        "#9EDAE5FF", "#F74ED6FF", "#19B2FFFF", "#32FF00FF", "#FF363CFF", "#8CDB5EFF", "#0627B3FF", "#181818FF"]
      const myColor = d3.scaleOrdinal(categories, colors);

      // Add xAxis
      let xScale = d3.scaleBand()
        .domain(samples)
        .range([margin.left, width - margin.right])
        .padding(1);

      // Add yAxis
      let yScale = d3.scaleBand()
        .domain([bandName])
        .range([margin.top, height])
      let yAxis = d3.axisLeft(yScale)
      svg.append("g")
        .attr("class", "y-axis")
        .attr("transform", `translate(${margin.left},${gridHeight / 2 - 8})`)
        .call(yAxis)
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll('.tick line').remove())
        .call(g => g.selectAll('.tick text').attr("font-size", "13")
          .attr("font-family", "Arial").attr("font-weight", "bold"));
      let yaxisText = d3.selectAll("div.sample-mutation")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .select('g.y-axis');
      yaxisText.attr('data-tippy-content', (d, i) => {
        return `<div>Gene Name | Fisher P Value | Mutation Ratio</div>`
      });
      tippy(yaxisText.nodes(), {
        allowHTML: true,
        placement: 'bottom',
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        maxWidth: 300,
        delay: 0,
        duration: [0, 0],
      });

      // Add Samples rect
      svg.append('g')
        .attr("class", "samples-all")
        .selectAll()
        .data(all_samples_cnv)
        .join("rect")
        .attr('x', d => xScale(d.sample_id))
        .attr('y', yScale(bandName) + gridHeight / 2)
        .attr('width', gridWidth)
        .attr('height', gridHeight)
        // .attr('rx', 0.5) // set border-radius
        .attr('stroke-width', 0.5) // set border-width
        .attr('fill', function (d) {
          if (d.cnv > 1) {
            return 'red'
          } else if (d.cnv < -1) {
            return 'blue'
          } else {
            return sampleColor
          }
        });
      let sample_rects = d3.selectAll("div.sample-mutation")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .selectAll('.samples-all rect');
      sample_rects.attr('data-tippy-content', (d, i) => {
        return `<div>Sample ID: ${d.sample_id}</div>`
      });
      tippy(sample_rects.nodes(), {
        allowHTML: true,
        placement: 'left',
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 300,
        delay: 0,
        duration: [0, 0],
      });

      // console.log(d3.selectAll("div.sample-mutation")
      //   .filter(function () { return d3.select(this).attr('id') == gene_name })
      //   .selectAll('.samples-all rect'));
      // Add CNV color
      // d3.selectAll("div.sample-mutation")
      //   .filter(function () { return d3.select(this).attr('id') == gene_name })
      //   .selectAll('.samples-all rect')
      //   .data(all_samples_cnv).attr('fill', function (d) {
      //     if (d.cnv > 1) {
      //       return 'red'
      //     } else if (d.cnv < -1) {
      //       return 'blue'
      //     } else {
      //       return sampleColor
      //     }
      //   });

      // Add mutation rect
      // console.log(all_samples_mutation);
      // all_samples_mutation.forEach(d => console.log(xScale(d.sample_id)));
      svg.append('g')
        .attr("class", "samples-mutation")
        .selectAll()
        .data(sampleMutations)
        .join("rect")
        .attr('x', d => xScale(d.sample_id))
        .attr('y', yScale(bandName) + gridHeight / 2 + 6)
        .attr('width', gridWidth)
        .attr('height', gridHeight / 3)
        .attr('stroke-width', 0.5) // set border-width
        .attr('fill', d => myColor(d.effect));
      let mutation_rects = d3.selectAll("div.sample-mutation")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .selectAll('.samples-mutation rect');
      mutation_rects.attr('data-tippy-content', (d, i) => {
        return `<div>Sample ID: ${d.sample_id}</div>
          <div>Location: chr${d.chr}:${d.start}-${d.end}</div>
          <div>Reference: ${d.reference}</div>
          <div>Alt: ${d.alt}</div>
          <div>Effect: ${d.effect}</div>`
      });
      tippy(mutation_rects.nodes(), {
        allowHTML: true,
        placement: 'left',
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 300,
        delay: 0,
        duration: [0, 0],
      })
    },
  },
}
</script>
<style scoped lang="sass">
.gene_pvalue
  font-family: "Arial",
</style>